var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"aside-section"},[_c('h2',[_vm._v("Education")]),_vm._l((this.institutions),function(institution,key){return _c('ResumeInstitution',{key:key,staticClass:"aside-content",attrs:{"institution":institution}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }